import {getMoreObituariesQuery} from './templates/queryTemplates';
import gatewayFetch from '../../appModules/utilities/gatewayFetch';
import {refreshAds} from '../../appModules/utilities/refreshAds';
import {setVirtualPageView} from '../shared/utilities/GAHelpers';
import {buildDirectoryPath} from '../../appModules/utilities/metaDataUtilities';
import {buildUrl} from '../shared/utilities/urlHelpers';
import appConfig from '../../appConfig/AppConfig';
import {
  OBITUARIES_REQUEST,
  OBITUARIES_SUCCESS,
  OBITUARIES_ERROR,
} from './actions';

const conf = appConfig();

const obituariesRequest = () => ({
  type: OBITUARIES_REQUEST,
});

const obituariesSuccess = (response, count) => ({
  type: OBITUARIES_SUCCESS,
  response,
  count,
});

const obituariesError = error => ({
  type: OBITUARIES_ERROR,
  error,
});

/**
 * @param  {number}   funeralHomeId funeralHomeId
 * @param  {number}   affiliateId Affiliate ID
 * @param  {number}   count Number of obituaries to return
 * @return {function} returns the function to make the fetch
 */
export function getMoreObituaries(funeralHomeId, affiliateId = 0, count = 10) {
  return (dispatch, getState) => {
    const {
      obituaryStore: {page = 1},
    } = getState();
    const parameters = {
      count,
      affiliateId,
      offset: count * page,
    };
    const query = getMoreObituariesQuery(funeralHomeId, parameters);

    dispatch(obituariesRequest());

    if (funeralHomeId) {
      return gatewayFetch(query, 'query')
        .then(data => {
          const {obituaryStore, funeralHomeStore} = getState();
          const nextPageNumber = obituaryStore.page + 1;
          const nextPageParameters =
            nextPageNumber > 1 ? [{key: 'page', value: nextPageNumber}] : null;
          const nextPageUrl = buildUrl(
            conf.vanityDomain,
            buildDirectoryPath(funeralHomeStore),
            nextPageParameters
          );

          setVirtualPageView(nextPageUrl);
          history.replaceState(null, null, nextPageUrl);
          refreshAds(['display-right-inview-1', 'display-right-inview-2']);
          dispatch(obituariesSuccess(data, count));
        })
        .catch(error => {
          dispatch(obituariesError(error));
        });
    }

    dispatch(obituariesError(new Error('No get parameters present')));
  };
}



// WEBPACK FOOTER //
// ./src/reactModules/redux/obituariesHelper.js